import React, { Component } from 'react';
import UA from '../../utils/ua';
import './Vdieo.less';

// import paused from '../../static/images/util-template/paused.png';
// import playing from '../../static/images/util-template/playing.png';

export default class Vdieo extends Component {
    constructor(props){
        super(props);
        this.state={
            btnStatus: 'paused',
            showBtn: true
        }
    }
    btnClick = (e) => {
        window.event? window.event.cancelBubble = true : e.stopPropagation();
        const { btnStatus } = this.state;
        if(btnStatus === 'paused'){
            this.video.play();
            this.setState({
                btnStatus: 'playing',
                showBtn: false
            })
        }
        else{
            this.video.pause();
            clearTimeout(this.timeout);
            this.setState({
                btnStatus: 'paused',
                showBtn: true
            })
        }
    }
    wrapClick = (type) => {
        if(type === 'click' && !UA.mobileClient) return false;
        const { showBtn, btnStatus } = this.state;
        if(showBtn || btnStatus === 'paused') return false;
        else{
            // console.log(type)
            this.setState({
                showBtn: true
            });
            this.timeout = setTimeout(()=>{
                this.setState({
                    showBtn: false
                });
            },2000)
        }
    }
    render(){
        // const { btnStatus, showBtn } = this.state;
        const { src, style, className, poster } = this.props;
        return(
            <div className={`video_wrap ${className}`}>
                <video 
                    src={src} 
                    style={{...style}} 
                    ref={com => {this.video = com}} 
                    poster={poster}
                    controls 
                    preload='auto' 
                    webkit-playsinline="true"
                    playsInline="true"
                    x-webkit-airplay="true"
                />
                {/* <div 
                    className={`btn_wrap ${btnStatus}`}
                    style={{backgroundImage:poster?`url(${poster})`:''}}
                    onClick={this.wrapClick.bind(this,'click')}
                    onMouseOver={this.wrapClick.bind(this,'over')}
                />
               <div className={`btn ${btnStatus} ${showBtn?'active':''}`} onClick={this.btnClick} /> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/UtilTemplate/Vdieo.jsx